import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { UserModuleOutput } from '../model/user-module.output';

export interface UpdateUserModulePageInput {
	readonly activityUrl: string;
	readonly pageId: string;
}

export interface UpdateUserModuleInput {
	readonly pages: UpdateUserModulePageInput[];
	readonly moduleId: string;
	readonly userId: string;
}

export interface UpdateUserModuleParams {
	input: UpdateUserModuleInput;
}

@Injectable({ providedIn: 'root' })
export class UpdateUserModuleApiMutation extends ApiMutation<
	UserModuleOutput,
	UpdateUserModuleParams
> {
	client = 'content';
	document = gql`
		mutation UpdateUserModule($input: UpdateUserModuleInput!) {
			updateUserModule(input: $input) {
				id
				isDone
				userId
				moduleId
				isStarted
				coachComment
				updateTimestamp
				moduleRatingValue
				moduleRatingComment
				module {
					id
				}
				pages {
					pageId
					activityUrl
					id
				}
			}
		}
	`;
	method = 'updateUserModule';
}
